export const fontWeights = [
  { key: 'Thin', text: _TL_('Thin') },
  { key: 'ExtraLight', text: _TL_('Extra light') },
  { key: 'Light', text: _TL_('Light') },
  { key: 'Normal', text: _TL_('Normal') },
  { key: 'Medium', text: _TL_('Medium') },
  { key: 'SemiBold', text: _TL_('Semi-bold') },
  { key: 'Bold', text: _TL_('Bold') },
  { key: 'ExtraBold', text: _TL_('Extra-bold') },
  { key: 'Black', text: _TL_('Black') },
];
